import { Container, Spinner } from "react-bootstrap";

const SplashScreen = () => {
    return (
        <Container
            fluid
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ height: "100vh" }}
        >
            <Spinner animation="border" role="status" variant="primary" />
            <p className="mt-3 text-muted">Loading...</p>
        </Container>
    );
};

export default SplashScreen;